import { z } from 'zod';

export const submapSchema = z.object({
  id: z.number(),
});
